module.exports = __webpack_public_path__ + "media/images/country_flags/kg-4ee3a91270af5edb313e464a1d1e4eb0.png";